import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { errorMessage } from "../utils/api";
import QRForm from "../components/QRForm";
import { formatDateTime, formatNumber } from "../utils/format";

export default function QRListPage() {
  const navigate = useNavigate();
  const [codes, setCodes] = useState(null);
  const [error, setError] = useState("");
  const [creating, setCreating] = useState(false);

  useEffect(() => {
    api
      .get("/qrs")
      .then((res) => setCodes(res.data))
      .catch((err) => setError(errorMessage(err)));
  }, []);

  async function handleCreate(values) {
    try {
      const { data } = await api.post("/qrs", values);
      navigate(`/qrs/${data.id}`);
    } catch (err) {
      throw new Error(errorMessage(err));
    }
  }

  return (
    <>
      <div className="page-head">
        <h1>QR Kodlar</h1>
        {!creating && (
          <button className="btn btn-primary" onClick={() => setCreating(true)}>
            Yeni QR kod
          </button>
        )}
      </div>

      {creating && (
        <div className="card">
          <h2>Yeni QR kod</h2>
          <QRForm submitLabel="Oluştur" onSubmit={handleCreate} onCancel={() => setCreating(false)} />
        </div>
      )}

      {error && <div className="error">{error}</div>}
      {!codes && !error && <p className="muted">Yükleniyor…</p>}
      {codes && codes.length === 0 && <p className="muted">Henüz QR kod yok. İlkini oluşturun.</p>}

      {codes && codes.length > 0 && (
        <div className="card table-card">
          <table>
            <thead>
              <tr>
                <th>İsim</th>
                <th>Kısa link</th>
                <th>Hedef</th>
                <th>Durum</th>
                <th className="num">Okutma</th>
                <th>Son okutma</th>
                <th>Oluşturulma</th>
              </tr>
            </thead>
            <tbody>
              {codes.map((q) => (
                <tr key={q.id}>
                  <td>
                    <Link to={`/qrs/${q.id}`}>{q.name}</Link>
                  </td>
                  <td className="mono">{q.shortUrl}</td>
                  <td className="truncate" title={q.targetUrl}>
                    {q.targetUrl}
                  </td>
                  <td>
                    <span className={`badge ${q.active ? "badge-on" : "badge-off"}`}>{q.active ? "Aktif" : "Pasif"}</span>
                  </td>
                  <td className="num">{formatNumber(q.scans)}</td>
                  <td>{formatDateTime(q.lastScanAt)}</td>
                  <td>{formatDateTime(q.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
